import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight, Sparkles, BookOpen, Share2, FileText, Download, Clock, RotateCcw, Library, Globe } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

const FEATURES = [
  {
    icon: Sparkles,
    color: 'bg-purple-100 text-purple-700',
    titleEn: 'AI Teacher Hub',
    titleBi: 'AI Teacher Hub',
    descEn: 'We merged "AI Lesson Planner" and "AI Study Notes" into one powerful tool. Now you can generate lesson plans, study notes with AI diagrams, assessments, exams, and schemes — all from one place.',
    descBi: 'Mifala joenem "AI Lesson Planner" mo "AI Study Notes" i kam wan nomo. Nao yu save wokem lesson plan, study notes wetem AI pikja, assessment, exam, mo scheme — olgeta long wan ples nomo.',
    steps: {
      en: ['Go to AI Teacher Hub in the sidebar', 'Choose the Notes tab to generate study notes with AI images', 'Choose other tabs for lessons, exams, assessments, or schemes'],
      bi: ['Go long AI Teacher Hub long saed menu', 'Jusum Notes tab blong wokem study notes wetem AI pikja', 'Jusum narafala tab blong lesson, exam, assessment, o scheme']
    }
  },
  {
    icon: Share2,
    color: 'bg-emerald-100 text-emerald-700',
    titleEn: 'Share Notes to Students',
    titleBi: 'Serem Notes i Go Long Studen',
    descEn: 'After generating study notes, click "Share to Students" so your students can view them in their Student Portal. Students must answer practice questions before seeing the correct answers — this makes them think!',
    descBi: 'Afta yu wokem study notes, klikim "Share to Students" blong studen blong yu i save lukim long Student Portal blong olgeta. Studen mas ansarem practice question fastaem bifo oli lukim ansa — hemia i mekem oli tingting!',
    steps: {
      en: ['Generate notes in AI Teacher Hub → Notes tab', 'Click the "Share to Students" button on any note', 'Students will see it in their Study Materials tab'],
      bi: ['Wokem notes long AI Teacher Hub → Notes tab', 'Klikim "Share to Students" button long eni note', 'Studen bae luk long Study Materials tab blong olgeta']
    }
  },
  {
    icon: Library,
    color: 'bg-blue-100 text-blue-700',
    titleEn: 'Story Generator & Library',
    titleBi: 'Story Generator mo Library',
    descEn: 'Create illustrated stories for Year 1 & 2 students with vocabulary, comprehension activities, and colouring pages. Share your best stories to the school-wide Story Library so other teachers can use them too!',
    descBi: 'Wokem story wetem pikja blong Year 1 mo 2 studen, wetem vocabulary, comprehension, mo colouring page. Serem best story blong yu i go long Story Library blong school — narafala tija tu oli save yusum!',
    steps: {
      en: ['Go to Story Generator in the sidebar', 'Choose a theme and year level, then generate', 'Click "Share to Library" to let other teachers copy it'],
      bi: ['Go long Story Generator long saed menu', 'Jusum theme mo year level, afta klikim generate', 'Klikim "Share to Library" blong narafala tija oli save kopem']
    }
  },
  {
    icon: FileText,
    color: 'bg-green-100 text-green-700',
    titleEn: 'IA Program PDF & Word Documents',
    titleBi: 'IA Program PDF mo Word Document',
    descEn: 'Download your Internal Assessment program as a professional PDF or Word document. It includes the cover page, task summaries, scoring rubrics, feedback schedules, and your teacher signature + Principal signature + school stamp automatically.',
    descBi: 'Daonlodem Internal Assessment program blong yu olsem PDF o Word document. Hemia i gat cover page, task summary, scoring rubric, feedback schedule, mo signature blong yu wetem Principal signature mo school stamp — olgeta i go insaed otomatic.',
    steps: {
      en: ['Go to IA Programs in the sidebar', 'Select your subject and click Download PDF or Download Word', 'The document includes signatures and stamp automatically'],
      bi: ['Go long IA Programs long saed menu', 'Jusum subject blong yu mo klikim Download PDF o Download Word', 'Document i gat signature mo stamp finis otomatic']
    }
  },
  {
    icon: Download,
    color: 'bg-orange-100 text-orange-700',
    titleEn: 'PowerPoint (PPTX) Downloads',
    titleBi: 'PowerPoint (PPTX) Daonlod',
    descEn: 'You can now download your AI-generated lessons, study notes, and stories as PowerPoint presentations. Great for presenting in class or sharing with teachers who prefer slides.',
    descBi: 'Nao yu save daonlodem AI lesson, study notes, mo story olsem PowerPoint presentation. Hemia i gud blong presentem long klas o serem wetem narafala tija we oli laekem slides.',
    steps: {
      en: ['Open any generated lesson, note, or story', 'Click the PPTX / PowerPoint download button', 'Open it in PowerPoint or Google Slides'],
      bi: ['Openem eni lesson, note, o story we yu bin wokem', 'Klikim PPTX / PowerPoint download button', 'Openem long PowerPoint o Google Slides']
    }
  },
  {
    icon: Clock,
    color: 'bg-yellow-100 text-yellow-700',
    titleEn: 'Teacher Attendance — Late Reason',
    titleBi: 'Tija Attendance — Risen Blong Leit',
    descEn: 'If you sign in after 8:00 AM, the system now asks you to provide a reason for being late. This helps the Coordinator track attendance patterns and support teachers who face challenges getting to school on time.',
    descBi: 'Sapos yu saen in afta 8:00 AM, system bae askem yu blong talem risen blong leit blong yu. Hemia i helpem Coordinator blong lukaot long attendance mo sapotem tija we i gat problem blong kasem school long taem.',
    steps: {
      en: ['Sign in as normal at your school', 'If after 8:00 AM, a text box appears asking for your late reason', 'Type your reason (e.g. "Transport issue") and submit'],
      bi: ['Saen in olsem nomo long school blong yu', 'Sapos afta 8:00 AM, wan text box i kamaot blong askem risen', 'Taepem risen blong yu (e.g. "Transport problem") mo submit']
    }
  },
  {
    icon: RotateCcw,
    color: 'bg-red-100 text-red-700',
    titleEn: 'Draft Reset for IA Submissions',
    titleBi: 'Draft Reset Blong IA Submission',
    descEn: 'If a student was sick, had traditional obligations, or needs to redo a draft — you can now reset their submission. This deletes their old work and lets them re-upload fresh. The reason is logged for records.',
    descBi: 'Sapos wan studen i bin sik, gat kastom obligation, o nid blong mekem draft bakegen — nao yu save resetem submission blong hem. Hemia i deletem old wok mo letem hem i upload niuwan. Risen i stap long record.',
    steps: {
      en: ['Go to IA Programs → View student submissions', 'Find the student and click "Reset Draft"', 'Select a reason (Sick, Traditional, etc.) and confirm'],
      bi: ['Go long IA Programs → Lukim studen submission', 'Faendem studen mo klikim "Reset Draft"', 'Jusum risen (Sik, Kastom, etc.) mo confirm']
    }
  }
];

const GUIDE_VERSION = 'v2026-feb';

export function WhatsNewGuide({ isOpen, onClose }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [lang, setLang] = useState('en');

  if (!isOpen) return null;

  const feature = FEATURES[currentIndex];
  const Icon = feature.icon;
  const isEn = lang === 'en';

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100] flex items-center justify-center p-4" data-testid="whats-new-modal">
      <div className="bg-white rounded-2xl shadow-2xl max-w-xl w-full max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-indigo-600 to-purple-600 px-6 py-4 flex items-center justify-between">
          <div>
            <h2 className="text-white font-bold text-lg">
              {isEn ? "What's New" : "Wanem i Niu"}
            </h2>
            <p className="text-indigo-100 text-xs mt-0.5">
              {isEn ? `Feature ${currentIndex + 1} of ${FEATURES.length}` : `Fija ${currentIndex + 1} long ${FEATURES.length}`}
            </p>
          </div>
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="sm"
              className="text-white hover:bg-white/20 h-8 px-2 text-xs"
              onClick={() => setLang(l => l === 'en' ? 'bi' : 'en')}
              data-testid="lang-toggle-btn"
            >
              <Globe className="h-3.5 w-3.5 mr-1" />
              {isEn ? 'Bislama' : 'English'}
            </Button>
            <button onClick={onClose} className="text-white/80 hover:text-white" data-testid="close-guide-btn">
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>

        {/* Progress bar */}
        <div className="h-1 bg-gray-100">
          <div
            className="h-full bg-gradient-to-r from-indigo-500 to-purple-500 transition-all duration-300"
            style={{ width: `${((currentIndex + 1) / FEATURES.length) * 100}%` }}
          />
        </div>

        {/* Content */}
        <div className="px-6 py-5 overflow-y-auto" style={{ maxHeight: 'calc(90vh - 180px)' }}>
          <div className="flex items-start gap-4 mb-4">
            <div className={`p-3 rounded-xl ${feature.color}`}>
              <Icon className="h-6 w-6" />
            </div>
            <div>
              <h3 className="font-bold text-lg text-gray-900">
                {isEn ? feature.titleEn : feature.titleBi}
              </h3>
            </div>
          </div>

          <p className="text-sm text-gray-600 leading-relaxed mb-5">
            {isEn ? feature.descEn : feature.descBi}
          </p>

          {/* Steps */}
          <div className="bg-gray-50 rounded-xl p-4">
            <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">
              {isEn ? 'How to use' : 'Olsem wanem blong yusum'}
            </p>
            <div className="space-y-2.5">
              {(isEn ? feature.steps.en : feature.steps.bi).map((step, i) => (
                <div key={i} className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-indigo-100 text-indigo-700 text-xs font-bold flex items-center justify-center mt-0.5">
                    {i + 1}
                  </span>
                  <p className="text-sm text-gray-700">{step}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t bg-gray-50 flex items-center justify-between">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setCurrentIndex(i => Math.max(0, i - 1))}
            disabled={currentIndex === 0}
            data-testid="guide-prev-btn"
          >
            <ChevronLeft className="h-4 w-4 mr-1" /> {isEn ? 'Back' : 'Bak'}
          </Button>

          <div className="flex gap-1.5">
            {FEATURES.map((_, i) => (
              <button
                key={i}
                className={`w-2 h-2 rounded-full transition-all ${i === currentIndex ? 'bg-indigo-600 w-4' : 'bg-gray-300 hover:bg-gray-400'}`}
                onClick={() => setCurrentIndex(i)}
              />
            ))}
          </div>

          {currentIndex < FEATURES.length - 1 ? (
            <Button
              size="sm"
              onClick={() => setCurrentIndex(i => i + 1)}
              data-testid="guide-next-btn"
            >
              {isEn ? 'Next' : 'Nekis'} <ChevronRight className="h-4 w-4 ml-1" />
            </Button>
          ) : (
            <Button
              size="sm"
              className="bg-emerald-600 hover:bg-emerald-700"
              onClick={onClose}
              data-testid="guide-done-btn"
            >
              {isEn ? 'Got it!' : 'Okei!'}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}

export function useWhatsNew() {
  const storageKey = `whats_new_seen_${GUIDE_VERSION}`;
  const hasSeen = localStorage.getItem(storageKey) === 'true';

  const markSeen = () => {
    localStorage.setItem(storageKey, 'true');
  };

  return { shouldShow: !hasSeen, markSeen };
}
